/**
 * Shared formatting for Volta vs HPXML R + area lines (imperial R, m²).
 */

export function formatEnvelopeRAreaLines(details) {
    if (!details?.length) return "—";

    return details
        .map((d) => {
            const rPart = d.rImp != null && Number.isFinite(d.rImp) ? `R-${d.rImp.toFixed(2)}` : "R n/a";
            const aPart = d.areaM2 != null && Number.isFinite(d.areaM2) ? `${d.areaM2.toFixed(2)} m²` : "—";
            return `${rPart} [${aPart}]`;
        })
        .join("\n");
}

/** Volta `*_effRVal` fields are RSI; display as nominal imperial R (same scale as upgrades table). */
export function rsiEffToImperialR(rsi) {
    if (rsi == null || !Number.isFinite(Number(rsi))) return null;
    return Number(rsi) * 5.678;
}
